




































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'
import moment from 'moment'
import { DictRequest, DictParam, DictOptions, DictFilter, Certificates } from '@/types'
import { SIGNModule } from '@/store/signmodule'
import JSZip from 'jszip'
import FileSaver from 'file-saver'

@Component({
  name: 'Journals',
  components: {
    DictTable: () =>
      import(/* webpackChunkName: "DictTable" */ '@/components/DictTable.vue')
  }
})
export default class Journals extends Vue {
  dictName = 'EPLjournal'
  idx = EPLModule.DictIdx(this.dictName)
  tableKey = 0
  idxR = -1
  pickerFrom = false
  dateFrom = moment().format('YYYY-MM-DD')
  tzoffset = 0
  isShowForm = false
  showSignPDFDialog = false
  showSelectCertDialog = false
  journalID = -1
  thumbprint = ''
  pdfFileName = ''
  pdfData = ''
  sigFileName = ''
  sigData = ''
  certificates = [] as Certificates
  previewPDFsrc = ''
  previewHeight = 300
  loadingCert = false
  loadingPDF = false
  provider = ['']
  journalType = 1
  selectedEntUnits = []
  show = false

  mounted () {
    this.tzoffset = new Date().getTimezoneOffset() * 60
    EPLModule.fetchList({ dict: 'CUTUNITS', sourcetext: 'CUTUNITS', sourcevalue: 'qwe' })
      .then(() => {
        this.show = true
      })
    // список возможных отчётов
    this.idxR = EPLModule.DictIdx('ReportsList')
    const r = {} as DictParam
    r.idx = this.idxR
    r.request = {} as DictRequest
    r.request.options = { page: 1, itemsPerPage: -1 } as DictOptions
    r.request.filter = [] as Array<DictFilter>
    const rep = {} as DictFilter
    rep.field = 'isjournal'
    rep.condition = '1'
    rep.operator = '='
    rep.combine = 'AND'
    r.request.filter.push(rep)
    EPLModule.fetchDictData(r)
      .then(() => {
        if (EPLModule.dicts[this.idxR].rows.length > 0) {
          this.journalType = this.reports[0].id
        }
      })
  }

  get reports () {
    return EPLModule.dicts[this.idxR].rows
  }

  get entUnits () {
    return EPLModule.lists['CUTUNITS-CUTUNITS' as any]
  }

  get loading (): number {
    return EPLModule.loading
  }

  get dict () {
    return EPLModule.dicts[this.idx]
  }

  private getUnixTime (date: string): number {
    return parseInt(
      ((new Date(date).getTime() / 1000) + this.tzoffset).toFixed(0)
    )
  }

  get dateFormattedFrom () {
    return moment.unix(this.getUnixTime(this.dateFrom)).format('DD.MM.YYYY')
  }

  private clickRow (id: number) {
    let res = false
    this.dict.rows.forEach(r => {
      if (r.id === id) res = r.signed
    })
    this.journalID = -1
    if (res) {
      this.viewSignPDF(id)
    } else {
      this.selectCert(id)
    }
  }

  private signPDF () {
    let cert = ''
    this.certificates.forEach(c => {
      if (c.thumbprint === this.thumbprint) {
        const t = c.name.match(/T=([А-Яа-я\s]+),/)
        const sn = c.name.match(/SN=([А-Яа-я\s]+),/)
        const g = c.name.match(/G=([А-Яа-я\s]+),/)
        let tt = ''
        let tsn = ''
        let tg = ''
        if (t !== null) tt = t[1]
        if (sn !== null) tsn = sn[1]
        if (g !== null) tg = g[1]
        cert = `${tt}, ${tsn} ${tg}, № ${c.serial} действителен с ${c.fromdate} по ${c.todate}`
      }
    })
    SIGNModule.signCades({ thumbprint: this.thumbprint, docName: this.pdfFileName, data: this.pdfData })
      .then((sign: string) => {
        const name = this.pdfFileName.replace('.pdf', '.sig')
        EPLModule.signJournal({ id: this.journalID, cert: cert, data: sign, name: name })
          .then(() => {
            this.dict.rows.forEach(r => {
              if (r.id === this.journalID) {
                r.signed = this.getUnixTime(moment().format('YYYY-MM-DD'))
              }
            })
            // this.dict.rows[this.journalID].signed = true
            // this.dict.rows[this.journalID].signed = this.getUnixTime(moment().format('YYYY-MM-DD'))
          })
        this.certificates = []
        this.showSignPDFDialog = false
        this.thumbprint = ''
        this.pdfFileName = ''
        this.pdfData = ''
        this.previewPDFsrc = ''
        this.sigFileName = ''
        this.sigData = ''
      })
  }

  private downloadZip () {
    const zip = new JSZip()
    zip.file(this.pdfFileName, this.pdfData, { base64: true })
    zip.file(this.sigFileName, this.sigData)
    zip.generateAsync({ type: 'blob' })
      .then((content: any) => {
        FileSaver.saveAs(content, this.pdfFileName.replace('.pdf', '.zip'))
      })
  }

  private viewSignPDF (id: number) {
    this.showSignPDFDialog = true
    this.loadingCert = true
    this.loadingPDF = true
    EPLModule.getJournal({ type: 'pdf', id: id })
      .then((response: any) => {
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        this.pdfFileName = filename
        const fr = new FileReader()
        this.previewHeight = window.innerHeight - 120
        this.previewPDFsrc = window.URL.createObjectURL(new Blob([response.data]))
        fr.readAsDataURL(new Blob([response.data]))
        fr.onloadend = (result: any) => {
          console.log('load')
          const header = ';base64,'
          const fd = result.target.result
          this.pdfData = fd.substr(fd.indexOf(header) + header.length)
          this.loadingPDF = false
        }
        EPLModule.getJournal({ type: 'sign', id: id })
          .then(
            async (response: any) => {
              let filename = response.headers['content-disposition']
              filename = filename.substr(filename.search(/"/g) + 1)
              filename = filename.substr(0, filename.search(/"/g))
              this.sigFileName = filename
              let sign = ''
              const fr = new FileReader()
              fr.readAsText(new Blob([response.data]))
              fr.onload = async (result: any) => {
                sign = result.target.result
                this.sigData = result.target.result
                try {
                  this.provider = await SIGNModule.checkSignPDF({ data: this.pdfData, sign: sign })
                  this.loadingCert = false
                } catch (e) {
                  this.loadingCert = false
                  this.provider = [e]
                }
              }
            }
          )
      })
  }

  private async newJournal (thumbprint: string) {
    this.thumbprint = thumbprint
    this.showSelectCertDialog = false
    this.showSignPDFDialog = true
    this.loadingPDF = true
    let cert = ''
    this.certificates.forEach(c => {
      if (c.thumbprint === thumbprint) {
        const t = c.name.match(/T=([А-Яа-я\s]+),/)
        const sn = c.name.match(/SN=([А-Яа-я\s]+),/)
        const g = c.name.match(/G=([А-Яа-я\s]+),/)
        let tt = ''
        let tsn = ''
        let tg = ''
        if (t !== null) tt = t[1]
        if (sn !== null) tsn = sn[1]
        if (g !== null) tg = g[1]
        cert = `${tt}, ${tsn} ${tg}, № ${c.serial} действителен с ${c.fromdate} по ${c.todate}`
        this.provider = [cert]
      }
    })
    EPLModule.newJournal({ id: this.journalID, data: cert })
      .then((response: any) => {
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        const fr = new FileReader()
        this.previewHeight = window.innerHeight - 120
        this.previewPDFsrc = window.URL.createObjectURL(new Blob([response.data]))
        fr.readAsDataURL(new Blob([response.data]))
        fr.onloadend = (result: any) => {
          const header = ';base64,'
          const fd = result.target.result
          this.pdfFileName = filename
          this.pdfData = fd.substr(fd.indexOf(header) + header.length)
          this.loadingPDF = false
        }
      })
  }

  private async selectCert (id: number) {
    this.journalID = id
    this.thumbprint = ''
    this.pdfData = ''
    this.previewPDFsrc = ''
    this.showSelectCertDialog = true
    this.loadingCert = true
    try {
      const provider = await SIGNModule.checkProvider()
      this.provider = [provider]
      this.certificates = await SIGNModule.getCertificates()
      this.loadingCert = false
    } catch (e) {
      this.loadingCert = false
      this.provider = [e]
    }
  }

  private clickAdd () {
    this.isShowForm = true
  }

  private clickClose () {
    this.isShowForm = false
  }

  private save () {
    const data = {} as { entunits: string[], filter: DictFilter[] }
    data.entunits = this.selectedEntUnits
    data.filter = []
    const filter = {} as DictFilter
    filter.field = 'date'
    filter.condition = `${this.getUnixTime(this.dateFrom)}`
    filter.operator = '>='
    filter.combine = 'AND'
    data.filter.push(filter)
    EPLModule.addJournal({ id: this.journalType, data: JSON.stringify(data) })
      .then(() => {
        this.tableKey++
        this.isShowForm = false
      })
  }
}
